<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import type { WorkGalleryBlock } from '../../types'

defineProps<{ block: WorkGalleryBlock }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-background) site:py-16 site:@min-[40rem]:py-24">
    <div class="site-site-container">
      <div class="site:mx-auto site:max-w-3xl site:text-center">
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-primary)" />
        <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
        <SiteEditableText v-if="block.content.description" v-model="block.content.description" as="p" class="site:mt-5 site:text-lg site:leading-8 site:text-(--site-color-muted-text)" />
      </div>

      <div class="site:mt-12 site:grid site:gap-6 site:@min-[40rem]:grid-cols-2 site:@min-[64rem]:grid-cols-3">
        <article v-for="project in block.content.items" :key="project.id">
          <div class="site:aspect-[4/3] site:overflow-hidden site:bg-(--site-color-surface) site:shadow-(--site-shadow-sm)" :style="{ borderRadius: 'var(--site-radius-md)' }">
            <img v-if="project.afterImage ?? project.beforeImage" :src="(project.afterImage ?? project.beforeImage)?.src" :alt="(project.afterImage ?? project.beforeImage)?.alt ?? project.title ?? 'Completed project'" class="site:h-full site:w-full site:object-cover" loading="lazy" />
            <div v-else class="site:grid site:h-full site:place-items-center site:text-sm site:font-semibold site:text-(--site-color-muted-text)">Project image</div>
          </div>
          <div class="site:pt-5">
            <div class="site:flex site:flex-wrap site:gap-x-3 site:gap-y-1 site:text-xs site:font-semibold site:text-(--site-color-primary)">
              <SiteEditableText v-if="block.settings.showCategory !== false && project.category" v-model="project.category" as="span" />
              <SiteEditableText v-if="block.settings.showLocation !== false && project.location" v-model="project.location" as="span" class="site:text-(--site-color-muted-text)" />
            </div>
            <SiteEditableText v-if="project.title" v-model="project.title" as="h3" class="site-heading site:mt-2 site:text-xl site:font-bold" />
            <SiteEditableText v-if="project.description" v-model="project.description" as="p" class="site:mt-2 site:leading-7 site:text-(--site-color-muted-text)" />
          </div>
        </article>
      </div>
      <div v-if="block.content.action" class="site:mt-10 site:text-center"><SiteLink :link="block.content.action" class="site-site-button">{{ block.content.action.label }}</SiteLink></div>
    </div>
  </section>
</template>
